import { Stack, TextField, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { regexCalc } from "../util/fnRegexCalc";

function MapOption({ result, setResult, engResult, setEngResult, isKor, setIsKor, regexOperator, setRegexOperator }) {

  function getOptionRegex(e) {
    let regex = '';
    let engRegex = '';

    if(e.target.value.length < 2) {
      setResult((prev) => ({...prev, [e.target.id] : ''}));
      setEngResult((prev) => ({...prev, [e.target.id] : ''}));
      return;
    }

    const value = regexCalc(e.target.value);

    if(e.target.id === 'quantity') {
      regex = '수량:.*' + value;
      engRegex = 'm q.*' + value;
    } else if(e.target.id === 'packSize') {
      regex = '규모:.*' + value;
      engRegex = 'iz.*' + value;
    } else if(e.target.id === 'scarab') {
      regex = '갑.*' + value;
      engRegex = 'sc.*' + value;
    } else if(e.target.id === 'currency') {
      regex = '화.*' + value;
      engRegex = 'cu.*' + value;
    } else if(e.target.id === 'map') {
      regex = '지도.*' + value;
      engRegex = 'map.*' + value;
    }
    setResult((prev) => ({...prev, [e.target.id] : regex}));
    setEngResult((prev) => ({...prev, [e.target.id] : engRegex}));
  }

  const fieldSx = { width: { xs: '100%', sm: 168 } };

  return (
    <Stack spacing={1.5} sx={{ mt: 1 }}>
      <Stack direction="row" flexWrap="wrap" gap={1.5} alignItems="center" justifyContent="space-between">
        <Stack direction="row" flexWrap="wrap" gap={1.5} sx={{ flex: 1 }}>
          <TextField id="quantity" label="아이템 수량 ≥" type="search" size="small" onChange={getOptionRegex} sx={fieldSx} />
          <TextField id="packSize" label="몬스터 무리 규모 ≥" type="search" size="small" onChange={getOptionRegex} sx={fieldSx} />
        </Stack>
        <ToggleButtonGroup
          value={isKor ? 'kor' : 'eng'}
          exclusive
          size="small"
          onChange={(_, v) => v && setIsKor(v === 'kor')}
        >
          <ToggleButton value="kor">한글</ToggleButton>
          <ToggleButton value="eng">영문</ToggleButton>
        </ToggleButtonGroup>
      </Stack>

      <Stack direction="row" flexWrap="wrap" gap={1.5} alignItems="center">
        <ToggleButtonGroup
          value={regexOperator}
          exclusive
          size="small"
          onChange={(_, v) => v && setRegexOperator(v)}
        >
          <ToggleButton value="OR">OR</ToggleButton>
          <ToggleButton value="AND">AND</ToggleButton>
        </ToggleButtonGroup>
        <TextField id="scarab" label="갑충석 더 많음 ≥" type="search" size="small" onChange={getOptionRegex} sx={fieldSx} />
        <TextField id="currency" label="화폐 더 많음 ≥" type="search" size="small" onChange={getOptionRegex} sx={fieldSx} />
        <TextField id="map" label="지도 더 많음 ≥" type="search" size="small" onChange={getOptionRegex} sx={fieldSx} />
      </Stack>
    </Stack>
  );
}

export default MapOption;
